/**
 * Returns the localized value of a field from a data object.
 * Looks for `field_lang` (e.g. description_en), falls back to `field`.
 */
export const localize = (obj, field, lang) => {
  if (lang === 'pt') return obj[field] || '';
  const localized = obj[`${field}_${lang}`];
  return localized || obj[field] || '';
};

/**
 * Returns a localized copy of an entire data object for the given fields.
 */
export const localizeObj = (obj, fields, lang) => {
  const result = { ...obj };
  for (const field of fields) {
    result[field] = localize(obj, field, lang);
  }
  return result;
};
